"use client";

import { useState } from "react";
import { Info } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet";
import { useAdminOverlay } from "./admin-overlay-context";

// Pense-bête admin : la demande initiale telle que collée depuis la
// plateforme, et le message publié sur Codeur.com (teaser), pour comparer
// rapidement avec ce que la page affiche sans rouvrir l'admin. Fixé en haut à
// droite (le sommaire des sections est en bas à gauche, la réservation
// Cal.com en bas à droite) : cette branche n'est jamais rendue côté visiteur,
// voir la garde `isAdmin` dans [slug]/page.tsx.
export function AdminBriefPopup() {
  const { data } = useAdminOverlay();
  const [open, setOpen] = useState(false);

  const brief = data.initialRequest?.trim();
  const teaser = data.introMessages?.teaser?.trim();
  if (!brief && !teaser) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Demande initiale et message Codeur.com"
        className="fixed right-6 top-6 z-50 inline-flex h-12 w-12 items-center justify-center rounded-full border border-paper/20 bg-navy text-paper shadow-2xl shadow-navy/40 transition-colors hover:bg-gold hover:text-navy hover:border-gold"
      >
        <Info className="h-5 w-5" strokeWidth={2} />
      </button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full overflow-y-auto sm:max-w-lg">
          <SheetHeader>
            <SheetTitle>Demande initiale et message Codeur.com</SheetTitle>
            <SheetDescription>Visible uniquement en session admin.</SheetDescription>
          </SheetHeader>

          <div className="space-y-6 px-4 pb-6">
            {brief && (
              <div>
                <div className="text-sm font-medium text-muted-foreground">
                  Demande initiale
                </div>
                <p className="mt-2 whitespace-pre-wrap text-sm">{brief}</p>
              </div>
            )}
            {teaser && (
              <div>
                <div className="text-sm font-medium text-muted-foreground">
                  Message Codeur.com
                </div>
                <p className="mt-2 whitespace-pre-wrap text-sm">{teaser}</p>
              </div>
            )}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
